<menu></menu>
<div id="container">
    <div class="form">
        <div class="header" table=true style="--cs:1fr 50px">
            <span>Listagem de Culturas</span>
            <mat-icon (click)="edit(null)">note_add</mat-icon>
        </div>
        <div class="struct" id="struct">
            <buscacultura *ngIf="!loading" [data]="culturas" (sign)="edit($event)"></buscacultura>
        </div>
    </div>
</div>
<spinner *ngIf="loading"></spinner>